import moment from 'moment'

export const getPreferredSnapshot = (event) => {
	const firstEventType = event.type.split(',')[0];
	const snapshot2Types = [
		'External Driver',
		'Driver',
		'Drowsiness',
		'Distraction',
		'Phone Use',
		'Phone Use/Hand to Head',
		'Yawning',
		'Drowsiness/Head Down'
	];
	if ((snapshot2Types.includes(firstEventType) || event.event_type.includes('DmsWarning')) && event.snapshot_2) {
		return event.snapshot_2;
	}
	return event.snapshot_1
}

// FWSD-4679
export const eventStatusFormatter = (cell) => {
	switch (cell) {
		case 'VIDEO_UPLOADED':
		case 'SNAPSHOT_UPLOADED':
			return 'Uploaded'
		case 'VIDEO_NON_EXIST':
			return 'No Video On Device'
		case 'SNAPSHOT_NON_EXIST':
			return 'No Snapshot On Device'
		case 'CONVERTED_FAILED':
			return 'Conversion Error'
		case 'TRANSFERRING_FAILED':
			return 'Download Error'
		case 'FAILED':
			return 'Event Failed'
		case 'VIDEO_REQUESTED':
		case 'SNAPSHOT_REQUESTED':
		case 'EVENT_REPORTED':
			return 'Pending'
		case 'PARTIAL_VIDEO':
			return 'Video Partial'
		default:
			return cell
	}
}

//* returns the filter name what should be displayed in the event filter menu
export const getFilterName = (filterArg) => {
	let name = ''

	switch (filterArg) {
		case 'videouploaded':
			name = 'Uploaded'
			break
		case 'videopending':
			name = 'Pending'
			break
		case 'videononexist':
			name = 'No Video On Device'
			break
		case 'videoconvertedfailed':
			name = 'Conversion Error'
			break
		case 'videotransferringfailed':
			name = 'Download Error'
			break
		case 'videofilesconverted':
			name = 'Files Converted'
			break
		case 'videofailed':
			name = 'Event Failed'
			break
		case 'videoundefined':
			name = 'Unknown'
			break
		default:
			name = filterArg
			break
	}

	return name
}

export const eventTypeDetection = (event) => {
	let type;

	if (!event) {
		return 'No Event Type'
	}

	// FWSD-4541
	if (event.event_display_type) {
		type = event.event_display_type;
	}
	else {
		// FWSD-3958
		const re = /External Driver|InputSensor2|InputSensor3|InputSensor5|InputSensor9/g;
		let typesArr = String(event.type)
			.replaceAll(re, 'Driver Event')
			.replace('HighSpeed', 'Max Speed')
			.replace(/CameraBlock|Potential Ch2 Obstruction/g, 'Camera Blocked/Misaligned') // FWSD-7911
			.split(',')

		// FWSD-4506
		if (typesArr.length > 1) {
			if (typesArr.includes('High G-Force')) {
				typesArr = ['High G-Force']
			}
			else {
				typesArr = typesArr.filter(item => item !== 'Critical G-Sensor')
			}
		}

		type = [...new Set(typesArr)].join(', ').replace('Custom Alert ', '')

		// FWSD-5202, FWSD-7032
		if (['Geotab', 'Ituran'].includes(event.type)) {
			type = event.rule || event.type
		}
		// FWSD-4379
		else if (event.uploading_status && event.uploading_status.toLowerCase() === 'video_non_exist' && event.type === 'Custom Clip') {
			type = 'Custom Clip'
		}
	}

	return type
}

export const detectDSTChangeType = (videoDate) => {
	// debugger
	// const start_time = momenttz(moment(videoDate).format('YYYY-MM-DD 00:00:00')).format('YYYY-MM-DDTHH:mm:ss')
	// const end_time = momenttz(moment(videoDate).format('YYYY-MM-DD 23:59:59')).format('YYYY-MM-DDTHH:mm:ss')
	// const tz = momenttz().utcOffset();
	// const timezone = 'UTC' + ((tz > 0) ? '+' : '') + tz/60

	// Automatically get the user’s local time zone
	const tzname = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
	// const startMoment = moment.tz(start, timeZone);
	// const endMoment = moment.tz(end, timeZone);
	// const startMoment = moment.tz(start_time, timeZone);
	// const endMoment = moment.tz(end_time, timeZone);

	// Start and end of the selected day *in user's local zone*
	const startMoment = moment.tz(`${moment(videoDate).format('YYYY-MM-DD')}T00:00:00`, tzname);
	const endMoment = moment.tz(`${moment(videoDate).format('YYYY-MM-DD')}T23:59:59`, tzname);
  
  
	const startOffset = startMoment.utcOffset(); // in minutes
	const endOffset = endMoment.utcOffset();
  
	if (startOffset === endOffset) {
	  return { hasDSTChange: false, type: null, tzname };
	}
  
	const type =
	  startOffset < endOffset
		? 1 // "Spring Forward (lost 1 hour)"
		: 2 //"Fall Back (gained 1 hour)";
  
	return { hasDSTChange: true, type, tzname };
  }
